import CompetingFirm from '@/domain/competing-firm/entity/competing-firm.entity';
import Csm from '@/domain/csm/entity/csm.entity';
import Feature from '@/domain/feature/entity/feature.entity';
import IntegrationType from '@/domain/integration-type/entity/integration-type.entity';
import { JustificationMigrationCompeting } from '@/domain/justify/domain/justification-migration-competing.enum';
import LeadOrigin from '@/domain/lead-origin/entity/lead-origin.entity';
import LeadSource from '@/domain/lead-source/entity/lead-source.entity';
import Portfolio from '@/domain/portfolio/entity/portfolio.entity';
import Segment from '@/domain/segment/entity/segment.entity';
import Seller from '@/domain/seller/entity/seller.entity';

export default class ContractAdditionalInfoRequest {
  justification: string;

  csm: Csm;

  segment: Segment;

  seller: Seller;

  leadSource: LeadSource;

  leadOrigin: LeadOrigin;

  features: Feature[];

  portfolio: Portfolio;

  potential: Portfolio;

  avgMonthlySales: number;

  healthScore: number;

  nps: number;

  integrationType: IntegrationType;

  competingFirm: CompetingFirm;

  readonly migrationToCompetingFirmId = JustificationMigrationCompeting.MIGRATION_TO_COMPETING_FIRM;

  constructor(obj: any = {}) {
    this.justification = obj.justification || null;
    this.csm = obj.csm || null;
    this.segment = obj.segment || null;
    this.seller = obj.seller || null;
    this.leadSource = obj.leadSource || null;
    this.leadOrigin = obj.leadOrigin || null;
    this.features = obj.features || null;
    this.portfolio = obj.portfolio || null;
    this.potential = obj.potential || null;
    this.avgMonthlySales = obj.avgMonthlySales || null;
    this.healthScore = obj.healthScore || null;
    this.nps = obj.nps || null;
    this.integrationType = obj.integrationType || null;
    this.competingFirm = obj.competingFirm || null;
  }

  public static of(obj: any = {}): ContractAdditionalInfoRequest {
    return new ContractAdditionalInfoRequest(obj || {});
  }

  public static ofList(obj: any[]): ContractAdditionalInfoRequest[] {
    return obj.map(this.of);
  }

  isMigrationToCompetingFirm(): boolean {
    return this.justification === this.migrationToCompetingFirmId;
  }
}
